import React, {Fragment} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
import {t, getLocale} from 'l10n';

import isEmpty from "lodash/isEmpty";
import { getMSLength, formatDate } from 'utils/wallMaterials';
import { LocalizedLink } from '../../components/ReactRouterDomLocalized';
import ProfileLink from 'components/ProfileLink';
import paths from 'paths';

import './listItem.scss';

const ListItem = ({ material, type, showDate, showStats, target, tag, order }) => {
    const locale = getLocale();
    const video = type === 'video' || material.type === 'video';
    const gift = type === 'real_gift' || type === 'virtual_gift';
    let link = !isEmpty(tag) ?
        `${material.url.slice(0, -1)}#context=tag:${locale === "en" ? tag.slug_en : tag.slug}`
        : material.url;

    if (type === 'real_gift') {
        link = paths.wishlists.path
    } else if (type === 'virtual_gift') {
        link = paths.profile.toPath({ nick: material.receiver.nick })
    } else if (type === 'bobstore') {
        link = null;
    }

    if (order && order !== "date") {
        if(link) {
            if (link.includes('#')) {
                link = link + `&order=${order}`
            } else {
                link = link.slice(0, -1) + `#order=${order}`
            }
        }
    }
    if (!material) return null;
    return(
        <div className='list-item-wrapper'>
            <div className={'list-item ' + type}>
                <LocalizedLink to={link} href={material.alias} className='thumbnail' target={target ? target : null}>
                    <img src={material.thumbnail_url || material.filename} alt={material.title}/>
                    {video &&
                        <Fragment>
                            <div className='fon-get-film'>
                                <div className='play'/>
                            </div>
                            <div className='time'>{getMSLength(material)}</div>
                        </Fragment>
                    }
                </LocalizedLink>
                {!gift && (
                    <div className='author-img'>
                        <img src={material.user.avatar_url} alt={material.user.nick}/>
                    </div>
                )}
                {gift ? (
                    <div className='text'>
                        <p>{material.gift_name} {t('given by')} {material.sender ? (<ProfileLink user={material.sender} />) : t('Anonymous')} {t('to')} <ProfileLink user={material.receiver}/></p>
                    </div>
                ) : (
                    <div className='text'>
                        <div className='author-block'>
                            <div className='author-name'>
                                <ProfileLink user={material.user}/>
                            </div>
                        </div>
                        <p className='title'>{material.title || material.name || material.gift_name}</p>
                        {showDate && <div className='date'>{formatDate(material)}</div>}
                    </div>
                )}
                {showStats &&
                    <div className='stats'>
                        {video && <div className='views'>{material.views || 0}</div>}
                        <div className={material.is_liked ? 'like highlight' : 'like'}>{material.like_count}</div>
                        <div className='message'>{material.comment_count}</div>
                    </div>
                }
            </div>
        </div>
    )
};

ListItem.defaultProps = {
    tag: {},
    showDate: false,
    showStats: false,
};

ListItem.propTypes = {
    tag: PropTypes.object,
    showDate: PropTypes.bool,
    showStats: PropTypes.bool,
    type: PropTypes.string.isRequired,
    order: PropTypes.string.isRequired,
    material: PropTypes.object.isRequired,
};

export default withRouter(ListItem);



// WEBPACK FOOTER //
// ./src/components/materialList/listItem.js